import FacilityInfo from "@/views/reporting/NonResidentialHauler/FacilityInfo.vue";
import Materials from "@/views/reporting/NonResidentialHauler/Materials.vue";

export default {
    FacilityInfo,
    Materials
}